export const BAL_TYPE = {
  currentAvailable: 'CurrentAvailable',
  currentPrincipal: 'CurrentPrincipal',
  single: 'single',
  recurring: 'recurring'
};

export const TRANSFER_FORM_FIELDS = {
  APPROVED_BY: 'approvedBy',
  APPROVED_DATE: 'approvedDate',
  AMOUNT: 'amount',
  BANK_TRACE_NUMBER: 'bankTraceNumber',
  CREDIT_ACCOUNT_ID: 'creditAccountId',
  DEBIT_ACCOUNT_ID: 'debitAccountId',
  ENTRY_DATE: 'entryDate',
  GLU_NAME: 'gluName',
  MEMO: 'memo',
  PROCESSING_DATE: 'processingDate',
  RECURRING: 'recurring',
  IS_RECURRING: 'isRecurring',
  STATUS: 'status',
  TEMPLATE_NAME: 'templateName',
  TYPE: 'type',
  USER_CODE: 'userCode'
};

export const BALANCE_TYPES = {
  CURRENT_AVAILABLE: 'CurrentAvailable',
  CURRENT_PRINCIPAL: 'CurrentPrincipal'
};

export const LOAN_ACCOUNT = 'loan';
